export default __webpack_public_path__ + "2bb6c576b5f6ac058101eae132a1e190.png";